import {
  Form, FormActionsAlign, FormHandlers, FormSubmitType,
  SelectOption,
} from '@doveit/bricks';
import React from 'react';
import { updateSupervisorFormValidationSchema } from './UpdateSupervisorForm.schema';

export interface UpdateSupervisorFormModel {
  supervisor?: string,
}

export interface UpdateSupervisorFormProps {
  onSubmit: FormSubmitType<UpdateSupervisorFormModel>,
  supervisors?: SelectOption[],
  initialValues?: Partial<UpdateSupervisorFormModel>,
  innerRef?: React.MutableRefObject<FormHandlers>
  disabled?: boolean,
  loading?: boolean,
  noSubmit?: boolean,
}

export const DEFAULT_INITIAL_VALUES: UpdateSupervisorFormModel = {
  supervisor: undefined,
};

const UpdateSupervisorForm: React.FC<UpdateSupervisorFormProps> = ({
  initialValues,
  supervisors = [],
  ...rest
}) => {
  const mergedInitialValues: UpdateSupervisorFormModel = React.useMemo(() => ({
    ...DEFAULT_INITIAL_VALUES,
    ...initialValues,
  }), [initialValues]);

  return (
    <Form
      initialValues={mergedInitialValues}
      enableReinitialize
      validationSchema={updateSupervisorFormValidationSchema}
      {...rest}
    >
      <Form.Item>
        <Form.Select
          name="supervisor"
          label="Gestore HR"
          aria-label="Campo per specificare il gestore HR"
          options={supervisors}
          required
        />
      </Form.Item>
      {!rest.innerRef && (
        <Form.Actions align={FormActionsAlign.RIGHT}>
          <Form.Submit label="Modifica" />
        </Form.Actions>
      )}
    </Form>
  );
};

export default UpdateSupervisorForm;
